import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Card} from 'reactstrap';
import LinesEllipsis from 'react-lines-ellipsis'
import { IoIosStar } from "react-icons/io";
import CdnImage from "../../../general/cdnImage/cdnImage";

const stateManager = require('../../../../../utils/state/stateManager');
const formatter = require('../../../../../utils/formatter/formatter');
const stringUtil = require('../../../../../utils/string/stringUtil');

class Items extends Component
{
    render()
    {
        var state = stateManager.getStore().getState();
        var menu = state.currentMenu;

        
        if (menu == null || menu.categories.length <= 0)
            return null;

        var childComponents = [];
        for (var index = 0; index < menu.categories.length; index++)
        {
            if (menu.categories[index].items.length <= 0)
                continue;

            this.renderCategory(menu, index, childComponents);
        }

        return <div style={{marginBottom:'20px'}}>
                    {childComponents}
               </div>
    }

    renderCategory(menu, categoryIndex, childComponents)
    {
        var category = menu.categories[categoryIndex];
        let htmlId = `menu-category-header-${categoryIndex}`;
        var menuItems = [];
        var bufferMenuItem;

        childComponents.push(<div id={htmlId}   
                                  style={{color:`var(--menu-category-font-color)`, 
                                          fontSize:`var(--menu-category-font-size-desktop)`, 
                                          paddingLeft:'65px',
                                          paddingRight:'65px',
                                          paddingTop:'15px',
                                          paddingBottom:'15px',
                                          fontWeight:'bold'}}>
                                {category.caption}
                             </div>)

        for (var index = 0; index < category.items.length; index++) 
        {
            if(category.items.length == 1)
            {
                menuItems.push(
                    <tr>
                        <td width="50%">
                            {this.renderItem(categoryIndex, category, index)}
                        </td>
                        <td>
                            
                        </td>
                    </tr>
                )                
                continue;
            }

            var secondMenuItem = null;
            if(index % 2 == 0)
            {
                bufferMenuItem = this.renderItem(categoryIndex, category, index);
                if (index + 1 < category.items.length)
                    continue;
            }
            else
            {
                secondMenuItem = this.renderItem(categoryIndex, category, index);
            }


            menuItems.push(
                <tr>
                    <td width="51%">
                        {bufferMenuItem}
                    </td>
                    <td>
                        {secondMenuItem}
                    </td>
                </tr>
            )
        }
        
        childComponents.push(<table width="100%"
                                    style={{
                                        marginBottom:'20px',
                                    }}>
                                {menuItems}
                            </table>);
    }

    renderItem(categoryIndex, category, itemIndex)
    {
        var item = category.items[itemIndex];
        var marginLeft = itemIndex % 2 == 0 ? '65px' : '20px';

        var component = <Card   style={{    
                                    marginTop:'20px',                                 
                                    marginLeft:marginLeft,
                                    paddingTop:'20px',
                                    paddingLeft:'20px',
                                    paddingRight:'20px',
                                    paddingBottom:'20px',
                                    borderBottom: `var(--menu-categories-bottom-border)`,}}
                            onClick={()=>{this.onItemClick(categoryIndex, category, itemIndex, item)}}>
                            <table>
                                <tr>
                                    <td width="80%" style={{verticalAlign: 'top'}}>
                                        <div style={{fontWeight:'bold'}}>
                                            {item.caption}
                                        </div>

                                        <div className='smallText'>
                                            <LinesEllipsis
                                                text={item.notes ?? ''}
                                                maxLine='3'
                                                ellipsis='...'
                                                trimRight
                                                basedOn='letters'
                                                />
                                        </div>
                                    </td>
                                    <td>
                                        {this.renderImage(item)}
                                    </td>
                                </tr>
                            </table>
                            <div style={{marginTop:'5px'}}>
                                            <table style={{display:'flex', flexDirection:'column', overflowX:'auto'}}>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>
                                                        {this.renderItemPrice(item)}
                                                    </td>
                                                    <td>
                                                        {this.renderIsPopularItemTag(item)}
                                                    </td>
                                                </tr>
                                            </table>
                                            
                                        </div>
                        </Card>
        
        return component;
    }

    renderItemPrice(item)
    {
        if (this.isItemAvailable(item))
            return formatter.convertToCurrencyFormat(item.price);

        return <div>
                    <span style={{textDecoration:'line-through'}}>{formatter.convertToCurrencyFormat(item.price)}</span>
                    <span style={{marginLeft:'5px'}}>Out Of Stock</span>
                </div>
    }

    renderIsPopularItemTag(item)
    {
        if (!item.isPopular)
            return null;

        return <span style={{ 
                                marginLeft:'10px', 
                                display:'inline-flex', 
                                alignItems: 'center', 
                                color:`var(--menu-item-popular-font-color)` }}
               >
                    <IoIosStar/>
                    <span style={{marginLeft:'5px'}}>Popular</span>
                </span>
    }

    renderImage(item)
    {
        var width = Math.round(window.innerWidth * 0.1);
        var height = Math.floor(width * 0.50);
        
        let grayScale = false;
        if (!this.isItemAvailable(item))
            grayScale = true

        if (!stringUtil.isStringNullOrEmpty(item.imageUrl))
        {
            var imageUrl = item.imageUrl;
            imageUrl = stringUtil.replaceAll(imageUrl, 'https://res.cloudinary.com/rms-uat-jinoby/image/upload/', '');
            imageUrl = stringUtil.replaceAll(imageUrl, 'https://res.cloudinary.com/rms-jinoby/image/upload/', '');

            return <div style={{marginLeft:'10px', border:`var(--menu-item-border)`}}>
                        <CdnImage publicId={imageUrl} height={height} width={width} grayScale={grayScale}/>
                    </div>
        }

        return <div style={{marginLeft:'10px', border:`var(--menu-item-border)`}}>
                    <CdnImage publicId={"menus/default.menu.image.png"} height={height} width={width} grayScale={grayScale}/>
                </div>
    }

    onItemClick(categoryIndex, category, itemIndex, item)
    {
        if (!this.isItemAvailable(item))
            return;

        this.props.onClick(categoryIndex, category, itemIndex, item);
    }

    isItemAvailable(item)
    {
        return item.enabled && !item.isSnoozed;
    }
}

const mapStateToProps = state => 
{
    return { 
        currentMenuCategoryIndex: state.currentMenuCategoryIndex,
    }
}

export default connect(mapStateToProps)(Items)